import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesBanners } from "../../constants";
import { BannersReorderBody } from "./bannersReorder.types";

export const requestBannersReorder = async ({
  bannerId,
  newOrder
}: BannersReorderBody): Promise<void> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesBanners.Banners,
      bannerId,
      ApiRoutesBanners.BannersReorder
    ),
    { newOrder }
  );
};
